module.exports = __webpack_public_path__ + "img/img2.4e8bbe12.jpg";